import styles from 'css/src/components/common/HelpDropdown.module.scss';

import React, { useCallback, useMemo, useState } from 'react';

import { KeyboardShortcutsModal } from './KeyboardShortcutsModal';
import { Dropdown, DROPDOWN_DIVIDER } from './ui/Dropdown';

import { SecondaryIconButton } from 'js/src/components/common/ui/Button';
import type { PlainDropdownItem } from 'js/src/components/common/ui/Dropdown';
import { MODAL_IDS, showModal } from 'js/src/data/modals';
import { DEMO_URL, HELP_DROPDOWN_OPTIONS } from 'js/src/libs/consts';
import { useAppDispatch } from 'js/src/libs/RootState';

type TItemProps = PlainDropdownItem<never> & {
    target?: string;
    onClick?: (e: React.MouseEvent) => void;
};

const ToggleButton: React.FC<{
    onClick: (e: React.MouseEvent) => void;
    disabled: boolean;
    ref?: React.Ref<HTMLDivElement>;
}> = React.memo(function ToggleButton({ onClick, disabled, ref }) {
    return (
        <div className={styles['help-dropdown-toggle']} ref={ref}>
            <SecondaryIconButton disabled={disabled} onClick={onClick} icon="help" />
        </div>
    );
});

export const HelpDropdown = () => {
    const dispatch = useAppDispatch();
    const [showingShortcuts, setShowingShortcuts] = useState(false);
    const hideShortcuts = useCallback(() => setShowingShortcuts(false), []);

    const itemPropsList = useMemo((): readonly TItemProps[] => {
        const onShowFeedbackModal = () =>
            dispatch(
                showModal({
                    modal_id: MODAL_IDS.SUBMIT_FEEDBACK,
                }),
            );
        return [
            HELP_DROPDOWN_OPTIONS.learn,
            HELP_DROPDOWN_OPTIONS.webinar,
            HELP_DROPDOWN_OPTIONS.feedback(onShowFeedbackModal),
            HELP_DROPDOWN_OPTIONS.support,
            HELP_DROPDOWN_OPTIONS.help,
            HELP_DROPDOWN_OPTIONS.shortcuts(() => setShowingShortcuts(true)),
            {
                id: DROPDOWN_DIVIDER,
            },
            {
                id: 'sales',
                href: DEMO_URL,
                target: '_blank',
                icon: 'phone',
                text: 'Contact sales',
            },
        ];
    }, [dispatch]);

    return (
        <>
            <Dropdown
                className={`nav-item ${styles['help-dropdown']} me-l5-12 d-flex align-items-center`}
                ToggleComponent={ToggleButton}
                items={itemPropsList}
                breakOverflow
            />
            <KeyboardShortcutsModal showing={showingShortcuts} onHidden={hideShortcuts} />
        </>
    );
};
